import HomepageTakover from '@propertypal/web-ui/src/products/HomepageTakeover';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Estate Agents Homepage Takeover - PropertyPal',
  description: 'Take Pride Of Place On The PropertyPal Homepage.',
  url: `/products/estate-agents/homepage-takeover`,
};

const AgentHomepageTakeover = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <HomepageTakover />
      <ProductsContact reason="Estate Agents Homepage Takeover" />
    </>
  );
};

export default AgentHomepageTakeover;
